import { PGliteWithExtensions } from "@/domains/database/utils/db";
import { runMigrations } from "@/domains/database/migrations/migration-runner";
import { migrations } from "@/domains/database/migrations";
import pTimeout, { TimeoutError } from "p-timeout";
import { DatabaseInitializationError } from "@/domains/errors/kinds/database";
import { DATABASE_CONFIG } from "../config";

export async function run({ db }: { db: PGliteWithExtensions }): Promise<void> {
  try {
    await pTimeout(runMigrations(db, migrations), {
      milliseconds: DATABASE_CONFIG.MIGRATION_TIMEOUT_MS,
      message: "Migration phase timed out",
    });
  } catch (error) {
    if (error instanceof TimeoutError) {
      throw new DatabaseInitializationError("Migration phase timed out", { phase: "migration" });
    }
    throw error;
  }
}
